import { render, staticRenderFns } from "./MyTournaments.vue?vue&type=template&id=a4e50fa2&scoped=true"
import script from "./MyTournaments.vue?vue&type=script&lang=js"
export * from "./MyTournaments.vue?vue&type=script&lang=js"
import style0 from "./MyTournaments.vue?vue&type=style&index=0&id=a4e50fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e50fa2",
  null
  
)

export default component.exports